// File: src/pages/Contact.jsx

import React, { useState } from "react";
import { supabase } from "../utils/supabaseClient";
import "./Contact.css";

export default function Contact() {
  const [org, setOrg] = useState("");
  const [website, setWebsite] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedback(null);

    if (!org || !email || !name) {
      setLoading(false);
      alert("Please fill in the required fields (District Name, Name, Email).");
      return;
    }

    try {
      const { error } = await supabase
        .from('inbound_requests')
        .insert([{ 
          organization: org, 
          website: website, 
          contact_name: name, 
          contact_email: email, 
          notes: notes 
        }]);

      if (error) throw error;

      setFeedback('success');
      setOrg("");
      setWebsite("");
      setName("");
      setEmail("");
      setNotes("");
    } catch (error) {
      console.error('Error submitting form:', error);
      setFeedback('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sales-page-container">
      <div className="sales-content-wrapper">
        
        {/* LEFT COLUMN */}
        <div className="sales-info">
          <h1 className="sales-title">Talk to our sales team</h1>
          
          <div className="sales-description">
            <p>
              BoardWatch transforms unstructured meeting video into a searchable 
              intelligence layer. If you are ready to modernize your district's 
              governance or need help with a custom implementation, we are here to help.
            </p>
            <p>
              Fill out the form to request access to BoardWatch.
            </p>
          </div>

          <div className="sales-comparison" style={{ 
            marginTop: 'var(--testimonial-margin-top)', 
            borderTop: '1px solid #e5e7eb',  /* 🌟 Added the grey line */
            paddingTop: '2rem'               /* 🌟 Added padding so text doesn't hit the line */
          }}>
            
            {/* Block 1: With BoardWatch (Now First) */}
            <div style={{ marginBottom: '1.5rem' }}>
              <h4 style={{ fontSize: '0.85rem', textTransform: 'uppercase', color: '#10b981', fontWeight: '700', letterSpacing: '0.05em', marginBottom: '0.5rem' }}>With BoardWatch</h4>
              <p style={{ fontSize: '1rem', color: '#111827', margin: 0, fontWeight: '500' }}>
                Search a keyword like "budget" and instantly jump to every mention across years of meetings.
              </p>
            </div>
            
            {/* Block 2: The Old Way (Now Second) */}
            <div>
              <h4 style={{ fontSize: '0.85rem', textTransform: 'uppercase', color: '#ef4444', fontWeight: '700', letterSpacing: '0.05em', marginBottom: '0.5rem' }}>The Old Way</h4>
              <p style={{ fontSize: '1rem', color: '#6b7280', margin: 0 }}>
                Manually watching 4-hour YouTube videos to find one specific agenda item timestamp.
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="sales-form-section">
          <h3 className="form-heading">Tell us about your organization</h3>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            
            <label htmlFor="org">District Name</label>
            <input
              id="org"
              type="text"
              placeholder="Your organization"
              value={org}
              onChange={(e) => setOrg(e.target.value)}
              required
            />

            <label htmlFor="website">Website / domain</label>
            <input
              id="website"
              type="text"
              placeholder="https://www.example.org"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />

            <div className="form-row-split">
              <div className="form-group">
                <label htmlFor="name">Primary contact name</label>
                <input
                  id="name"
                  type="text"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  placeholder="you@example.org"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <label htmlFor="notes">Notes (optional)</label>
            <textarea
              id="notes"
              rows="5"
              placeholder="Anything we should know about your coverage targets, timeline, or constraints."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />

            <button 
              type="submit" 
              className="contact-button"
              disabled={loading || feedback === 'success'}
            >
              {loading ? "Sending..." : feedback === 'success' ? "Request Sent!" : "Send request"}
            </button>

            {feedback === 'success' && (
              <p className="contact-success">Thanks! We've received your request.</p>
            )}
            {feedback === 'error' && (
              <p className="contact-error">Something went wrong. Please try again.</p>
            )}
          </form>
        </div>

      </div>
    </div>
  );
}